import { render, staticRenderFns } from "./CompetenceForm.vue?vue&type=template&id=308732da&scoped=true"
import script from "./CompetenceForm.vue?vue&type=script&lang=js"
export * from "./CompetenceForm.vue?vue&type=script&lang=js"
import style0 from "./CompetenceForm.vue?vue&type=style&index=0&id=308732da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308732da",
  null
  
)

export default component.exports